import { Typography } from "@mui/material";
import { Stack } from "@mui/system";
import "./Testimonials.css"
import React from "react";

function Testimonials({ title, desc, Icon }) {
    return (
        <>
            <Stack
                direction="row"
                gap={3}
                flexDirection={"column"}
                alignItems={"center"}
                className="cardTestim"
                p={2}
            >
                <Stack>
                    {Icon}
                    <Typography gutterBottom variant="h5" component="h5" sx={{
                        mb: 3,
                        fontWeight: "bold",
                        color: "#76232d",
                        fontSize: '1.75rem',
                    }}
                    >
                        {title}
                    </Typography>
                    <Typography gutterBottom variant="h6" component="h5" sx={{ fontSize: '1.5rem', }} >
                        {desc}
                    </Typography>
                </Stack>
            </Stack>
        </>
    );
}

export default Testimonials;
